// "Prices as of <date>" for an estimate that carries its own saved prices.
//
// The date is when those prices were captured: the first save, or the last
// time the user clicked Sync prices. Re-saving keeps it, because a re-save
// never changes a price (see buildSnapshot in App.tsx).

/** The badge text, e.g. "Prices as of Oct 14, 2026". */
export function pricesAsOfLabel(snapshotAt: string | null | undefined): string {
  if (!snapshotAt) return "Saved prices";
  const d = new Date(snapshotAt);
  if (Number.isNaN(d.getTime())) return "Saved prices";
  const date = d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return `Prices as of ${date}`;
}

/** The date to write into a saved file. Keeps the existing date when the file
 *  is priced from its own saved prices; otherwise the prices are live, so now. */
export function snapshotDateForSave(
  pricesFromFile: boolean,
  existing: string | null | undefined,
  now: Date = new Date()
): string {
  return (pricesFromFile && existing) || now.toISOString();
}
